<template>
  <v-app-bar :elevation="0" color="transparent" height="76" class="ws-appbar">
    <div class="ws-nav mx-auto d-flex align-center justify-space-between">
      <a
        class="ws-logo"
        role="button"
        aria-label="WeShare4Kids, naar home"
        @click="$router.push('/')"
      >
        <v-img
          style="width: 152px"
          src="@/assets/logo-landscape.svg"
          alt="WeShare4Kids"
          :eager="true"
        ></v-img>
      </a>

      <div
        class="d-flex align-center"
        v-if="!this.$vuetify.display.smAndDown"
        style="gap: 4px"
      >
        <button
          class="nav-pill"
          :class="{ active: isActive('/') }"
          :aria-current="isActive('/') ? 'page' : undefined"
          @click="$router.push('/')"
        >
          Home
        </button>

        <v-menu
          v-model="menuOverOns"
          open-on-hover
          open-delay="0"
          location="bottom"
          origin="top center"
        >
          <template v-slot:activator="{ props }">
            <button
              class="nav-pill"
              :class="{ active: isActive('/overons') }"
              :aria-current="isActive('/overons') ? 'page' : undefined"
              v-bind="props"
              @click="navigate('/overons')"
            >
              Over ons
            </button>
          </template>
          <v-list class="ws-menu-list" density="comfortable">
            <v-list-item
              v-for="(item, index) in overOns"
              :key="index"
              :value="index"
              @click="navigate(item.link)"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
          v-model="menuOrganisatie"
          open-on-hover
          open-delay="0"
          location="bottom"
          origin="top center"
        >
          <template v-slot:activator="{ props }">
            <button
              class="nav-pill"
              :class="{ active: isActive('/organisatie') }"
              :aria-current="isActive('/organisatie') ? 'page' : undefined"
              v-bind="props"
              @click="navigate('/organisatie')"
            >
              Organisatie
            </button>
          </template>
          <v-list class="ws-menu-list" density="comfortable">
            <v-list-item
              v-for="(item, index) in organisatie"
              :key="index"
              :value="index"
              @click="navigate(item.link)"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <button
          class="nav-pill"
          :class="{ active: isActive('/nieuws') }"
          :aria-current="isActive('/nieuws') ? 'page' : undefined"
          @click="$router.push('/nieuws')"
        >
          Nieuws
        </button>
        <v-menu
          v-model="menuFaq"
          open-on-hover
          open-delay="0"
          location="bottom"
          origin="top center"
        >
          <template v-slot:activator="{ props }">
            <button
              class="nav-pill"
              :class="{ active: isActive('/veelgestelde-vragen') }"
              :aria-current="
                isActive('/veelgestelde-vragen') ? 'page' : undefined
              "
              v-bind="props"
              @click="navigate(faqLinks[0].link)"
            >
              Veelgestelde vragen
            </button>
          </template>
          <v-list class="ws-menu-list" density="comfortable">
            <v-list-item
              v-for="(item, index) in faqLinks"
              :key="index"
              :value="index"
              @click="navigate(item.link)"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <button
          class="nav-pill"
          :class="{ active: isActive('/contact') }"
          :aria-current="isActive('/contact') ? 'page' : undefined"
          @click="$router.push('/contact')"
        >
          Contact
        </button>

        <button class="steun-btn" @click="$router.push('/steunons')">
          Steun ons
        </button>
      </div>

      <div v-else>
        <v-btn
          @click="$store.commit('setDrawer', !$store.state.drawer)"
          icon="mdi-menu"
          variant="text"
        ></v-btn>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { faqLinks } from "@/data/faq";

export default {
  data() {
    return {
      tab: 0,
      menuOverOns: false,
      menuOrganisatie: false,
      menuFaq: false,
      faqLinks,
      overOns: [
        { text: "Historie", link: "/overons#historie" },
        { text: "Missie", link: "/overons#missie" },
        { text: "Visie", link: "/overons#visie" },
        { text: "Werkwijze", link: "/overons#werkwijze" },
      ],
      organisatie: [
        { text: "Team", link: "/organisatie#team" },
        { text: "Beleid", link: "/organisatie#beleid" },
        { text: "ANBI verslag 2025", link: "/organisatie#anbi" },
        { text: "Partners", link: "/organisatie#partners" },
      ],
    };
  },
  watch: {
    // Close the hover dropdowns on any navigation (incl. browser back/forward).
    $route() {
      this.menuOverOns = false;
      this.menuOrganisatie = false;
      this.menuFaq = false;
    },
  },
  methods: {
    isActive(path) {
      if (path === "/") return this.$route.path === "/";
      return this.$route.path.startsWith(path);
    },
    navigate(path) {
      this.menuOverOns = false;
      this.menuOrganisatie = false;
      this.menuFaq = false;
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.ws-appbar {
  background: rgba(251, 244, 236, 0.82) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(42, 32, 24, 0.06);
}

.ws-nav {
  max-width: 1200px;
  width: 90vw;
}

.ws-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.nav-pill {
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #6b5d52;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 9px 15px;
  border-radius: 10px;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
  transition: background var(--ws-dur-fast) var(--ws-ease-out),
    color var(--ws-dur-fast) var(--ws-ease-out),
    transform var(--ws-dur-press) var(--ws-ease-out);
}
.nav-pill:hover {
  color: #2a2018;
  background: rgba(42, 32, 24, 0.04);
}
.nav-pill:active {
  transform: scale(0.97);
}
.nav-pill.active {
  color: #2a2018;
  background: rgba(234, 107, 38, 0.1);
}

.steun-btn {
  margin-left: 12px;
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 15px;
  color: #fff;
  background: #ea6b26;
  border: none;
  cursor: pointer;
  padding: 11px 22px;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(234, 107, 38, 0.32);
  white-space: nowrap;
  transition: background var(--ws-dur-fast) var(--ws-ease-out),
    box-shadow var(--ws-dur-fast) var(--ws-ease-out),
    transform var(--ws-dur-press) var(--ws-ease-out);
}
@media (hover: hover) and (pointer: fine) {
  .steun-btn:hover {
    background: #d65b1b;
    box-shadow: 0 8px 20px rgba(234, 107, 38, 0.42);
    transform: translateY(-1px);
  }
}
.steun-btn:active {
  transform: scale(0.97);
}

/* Smalle laptops: menu iets compacter zodat alles op één regel past */
@media screen and (max-width: 1140px) {
  .nav-pill {
    padding: 9px 9px;
  }
  .steun-btn {
    margin-left: 6px;
    padding: 11px 16px;
  }
}

.ws-menu-list {
  border-radius: 14px;
  margin-top: 6px;
  transform-origin: top center;
  box-shadow: 0 14px 40px -16px rgba(60, 36, 21, 0.32) !important;

  :deep(.v-list-item-title) {
    font-family: "Nunito", sans-serif;
    font-weight: 700;
    font-size: 14.5px;
    color: #5c4f44;
  }
}
</style>
